import { useEffect, useState } from 'react';
import { Button, IconButton, ResponsiveDialog, Stack, Text, TextArea, TextInput } from 'shell/components';

const AddCriterionDialog = ({ open, onClose, onSave }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (!open) {
            setTimeout(() => {
                setTitle('');
                setDescription('');
            }, 150);
        }
    }, [open]);

    return (
        <ResponsiveDialog open={open} onClose={onClose}>
            <Stack sx={{ minWidth: '300px' }} spacing={4}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text variant={'h6'} weight={'semibold'}>
                        Add New Criterion
                    </Text>
                    <IconButton kind={'exit'} size={'medium'} variant={'square'} onClick={onClose} />
                </Stack>
                <TextInput
                    autoFocus
                    label={'Name'}
                    placeholder={'Enter criterion name'}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <TextArea
                    label={'Description'}
                    placeholder={'Enter criterion description'}
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
                <Button sx={{ alignSelf: 'flex-end' }} onClick={() => onSave(title.trim(), description.trim())}>
                    Save
                </Button>
            </Stack>
        </ResponsiveDialog>
    );
};

export default AddCriterionDialog;
